import DynamicIcon from '@/components/DynamicIcon';
import i18n from '@/i18n';
import {
  MenuItemType,
  type MenuList,
  type RenderedMenuItem,
} from '@/types/menu.type';

export const getMenuItems = (menus: MenuList) => {
  const menuPathMap = new Map<string, RenderedMenuItem>();

  function renderMenuItems(
    menus: MenuList,
    parentItem: RenderedMenuItem
  ): RenderedMenuItem[] {
    return menus.reduce((acc: RenderedMenuItem[], menu) => {
      const menuItem = {
        key: menu.default || menu.path || menu.key || '',
        name: i18n.t('menu.' + menu.name || ''),
        path: menu.path ? menu.path : undefined,
        icon: menu.icon ? <DynamicIcon name={menu.icon} /> : undefined,
        default: menu.default,
        parent: parentItem?.path || '',
        menuPath: parentItem?.default || menu.default || menu.path || '',
        children: menu.children
          ? renderMenuItems(menu.children, menu)
          : undefined,
        onlyShowParent: menu.onlyShowParent || false,
      };
      if (menu.path) {
        menuPathMap.set(menu.path, menuItem);
      }
      if (menu.type === MenuItemType.Menu) {
        acc.push(menuItem);
      }
      return acc;
    }, []);
  }

  const menuItems = renderMenuItems(menus, {} as RenderedMenuItem);

  return { menuItems, menuPathMap };
};
